import { Link } from 'react-router-dom';
import { actorInfo } from '../../../mocks/portfolio';

const FilmographyFooter = () => {
  return (
    <footer className="bg-black border-t border-white/5">
      <div className="max-w-5xl mx-auto px-8 py-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-6">
            <Link to="/" className="text-white font-serif text-xl font-semibold tracking-wider hover:text-burgundy transition-colors cursor-pointer">
              JD
            </Link>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/jordandestin_/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 rounded-full border border-white/20 flex items-center justify-center text-stone-400 hover:bg-white hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a
                href="https://www.facebook.com/JordanDestin2.0"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 rounded-full border border-white/20 flex items-center justify-center text-stone-400 hover:bg-white hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a
                href="https://x.com/jordandestin"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 rounded-full border border-white/20 flex items-center justify-center text-stone-400 hover:bg-white hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a
                href="https://www.imdb.com/name/nm7411796/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 rounded-full border border-white/20 flex items-center justify-center text-stone-400 hover:bg-white hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-film-line text-sm"></i>
              </a>
            </div>
          </div>
          <div className="text-xs text-stone-600">
            &copy; 2025 {actorInfo.name}. All rights reserved. &middot;{' '}
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-stone-400 transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FilmographyFooter;
